import { render } from "./page_403.vue?vue&type=template&id=34cb2798&scoped=true"
import script from "./page_403.vue?vue&type=script&lang=js"
export * from "./page_403.vue?vue&type=script&lang=js"

import "./page_403.vue?vue&type=style&index=0&id=34cb2798&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34cb2798"]])

export default __exports__